<!-- src/app/personal-dashboard/personal-dashboard.component.html -->

<div class="container mt-4">
    <div class="row">
      <!-- LEFT SIDEBAR / PROFILE -->
      <div class="col-12 col-md-4 col-lg-3 mb-4">
        <div class="card">
          <img 
            src="assets/images/profile.jpg" 
            class="card-img-top" 
            alt="My Profile Picture">
          <div class="card-body">
            <h5 class="card-title">Michael Kerr</h5>
              <p class="card-text">
               Currently the CEO of All My Hugs, a family friendly Canadian company created to provide a way for loved ones to connect across distance, across time and across generations. Whether you want to leave a legacy or just connect with the people you love."
              </p>
          </div>
        </div>
      </div>
  
      <!-- RIGHT COLUMN: child route content gets injected here -->
      <div class="col-12 col-md-8 col-lg-9">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  
  
  <br /><br /><br />
  
  
  
  
  --
  <!-- src/app/personal-dashboard/personal-dashboard.component.html -->
   <!-- 
  <div class="container mt-4">
      <div class="row">
        <!-- LEFT SIDEBAR / PROFILE --
        <div class="col-12 col-md-4 col-lg-3 mb-4">
          <div class="card">
            <img 
              src="assets/images/profile.jpg" 
              class="card-img-top" 
              alt="My Profile Picture">
            <div class="card-body">
              <h5 class="card-title">Michael Kerr</h5>
              <p class="card-text">
               Currently the President and CEO of All My Hugs, a family friendly Canadian company created to provide a way for loved ones to connect across distance, across time and across generations. Whether you want to leave a legacy or just connect with the people you love."
              </p>
            </div>
          </div>
        </div>
    
        <router-outlet></router-outlet>
  
      </div>
    </div>
  -->